import { useState, useEffect } from 'react';
import WhoWeAre from './WhoWeAre';
import Blog from './Blog';
import TestimonialSection from './TestimonialSection';
import PricingSection from './PricingSection';
import GetInTouchSection from './GetInTouchSection';
import TradingService from './TradingService';
import RequestConsultation from './RequestConsultation';
import AttentionInvestors from './AttentionInvestors';

function Home() {
  const [showAttentionBox, setShowAttentionBox] = useState(false);

  useEffect(() => {
    // Show the attention box when component mounts
    const timer = setTimeout(() => {
      setShowAttentionBox(true);
    }, 1000); // Show after 1 second delay

    return () => clearTimeout(timer);
  }, []);

  const handleCloseAttentionBox = () => {
    setShowAttentionBox(false);
  };

  return (
    <div className="main-wrapper" style={{ overflowX: 'hidden' }}>
      {showAttentionBox && (
        <AttentionInvestors onClose={handleCloseAttentionBox} />
      )}
      
      <TradingService />
      <WhoWeAre />
      <TestimonialSection />
      <PricingSection />
      <GetInTouchSection />
      <RequestConsultation />
      <Blog />
    </div>
  );
}

export default Home;